'use strict';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/map';
import fuse from '../../../_libs/redux-fusion';
import {ReduxListStreamedContainer} from '../../../core-utilities/redux/ReduxListContainer';
import {componentOptions, reduxList} from '../../../timers/redux/assetTaskTimerLog';
import {TaskType} from '../../enums/TaskType';
import {assetTasksCtrlConfig} from '../../router-asset-tasks';
import {TaskViewTimerLogContainer} from './TaskViewTimerLogContainer';
import {TaskViewTimerLogView} from './TaskViewTimerLogView';


const StreamedComponent = TaskViewTimerLogContainer({
  taskType: TaskType.ASSET,
  taskListState: assetTasksCtrlConfig.taskListState,
});

export const ListComponent = ReduxListStreamedContainer(
  TaskViewTimerLogView,
  reduxList,
  componentOptions,
);
export const AssetTaskViewTimerLogContainer = fuse(StreamedComponent)(ListComponent);



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskViewTimerLog/AssetTaskViewTimerLogContainer.js